/**
 * Validates a string against a given regular expression pattern.
 *
 * @param {string} str - The string to validate.
 * @param {RegExp} pattern - The regular expression pattern to validate against.
 * @returns {boolean} - Returns true if the string matches the pattern, otherwise false.
 */

export function validateStringWithRegex(str) {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(str);
}
